import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"
import _imports_0 from '../assets/icons/warning.svg'


const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "error-title" }
const _hoisted_3 = {
  key: 0,
  class: "error-subtitle"
}
const _hoisted_4 = { class: "button-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "error-image" }, [
      _createElementVNode("img", {
        src: _imports_0,
        alt: "warning"
      })
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", null, _toDisplayString(_ctx.errorTitleText), 1)
    ]),
    (_ctx.errorDescriptionText)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("span", null, _toDisplayString(_ctx.errorDescriptionText), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.closeButtonText)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            id: "errorMessageCloseButton",
            class: "primary",
            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeButtonHandler && _ctx.closeButtonHandler(...args)), ["stop"]))
          }, _toDisplayString(_ctx.closeButtonText), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}